import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { UserService } from '../../core/services/user.service';

export const userTypeGuard = (
  route: ActivatedRouteSnapshot
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const userService = inject(UserService);

  return userService.getUserJourney().pipe(
    map((res) => {
      const currentRoute = route.routeConfig?.path;

      if (currentRoute === 'user-type') {
        if (res) {
          return router.parseUrl('/');
        } else {
          return true;
        }
      }

      if (res) {
        return true;
      } else {
        return router.parseUrl('/user-type');
      }
    })
  );
};
